// extracted by mini-css-extract-plugin
export default {"outerContainer":"GPie_outerContainer__f4v0Z","container":"GPie_container__x6Ovl","recharts-legend-item":"GPie_recharts-legend-item__Bt3SH","layout":"GPie_layout__AOTGK"};